import React from "react";
import {Grid} from "@material-ui/core";
import MuiPickersUtilsProvider from "@material-ui/pickers/MuiPickersUtilsProvider";
import DateFnsUtils from "@date-io/date-fns";
import ruLocale from "date-fns/locale/ru";
import {DatePicker} from "@material-ui/pickers";
import {ThemeProvider} from "@material-ui/styles";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";

const Theme = (borderRadius = "20px 20px") => createMuiTheme({
    overrides: {
        MuiOutlinedInput: {
            root: {
                borderRadius: borderRadius,
            },
            input: {
                padding: '10.5px 14px',
            }
        },
        MuiFormLabel: {
            root: {
                lineHeight: 0
            }
        }
    },
    palette: {
        primary: {
            main: '#95c61c'
        },

        secondary: {
            main: '#95c61c',
            light: '#b2d164'
        },
    },
});

class Filters extends React.Component
{
    render() {

        const {setDateFrom, setDateTo} = this.props;
        let maxdate = new Date();
        maxdate.setHours(maxdate.getHours() - maxdate.getTimezoneOffset() / 60);

        return (
            <Grid container alignItems={'stretch'} direction={'row'} justify={'wrap'}>
                <Grid item xs={6} lg={6} md={6} sm={6} style={{
                    display: 'flex',
                    justifyContent: 'end'
                }}>
                    <ThemeProvider theme={Theme('20px 0 0 20px')}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ruLocale}>
                            <DatePicker
                                disableToolbar
                                variant="inline"
                                inputVariant={'outlined'}
                                label="Дата с:"
                                value={this.props.dateFrom || null}
                                onChange={setDateFrom}
                                maxDate={this.props.dateTo}
                            />
                        </MuiPickersUtilsProvider>
                    </ThemeProvider>
                </Grid>
                <Grid item xs={6} lg={6} md={6} sm={6} style={{
                    display: 'flex',
                    justifyContent: 'start'
                }}>
                    <ThemeProvider theme={Theme('0 20px 20px 0')}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ruLocale}>
                            <DatePicker
                                disableToolbar
                                variant="inline"
                                inputVariant={'outlined'}
                                label="Дата по:"
                                value={this.props.dateTo || null}
                                onChange={setDateTo}
                                minDate={this.props.dateFrom}
                                maxDate={maxdate}
                            />
                        </MuiPickersUtilsProvider>
                    </ThemeProvider>
                </Grid>
                

            </Grid>
        );
    }
}


export default Filters